<template>
  <div>
    <q-dialog v-model="alert" persistent>
      <div class="hris-modal">
        <div class="hris-modal-header">
          <h2 class="hris-modal-title">Please confirm!</h2>
          <q-btn icon="fas fa-times" flat round dense class="hris-q-ghost" v-close-popup></q-btn>
        </div>
        <div class="hris-modal-body">
          <p>Your payslip password will be sent to this mobile number <strong>{{ mobile }}</strong></p>
          <p class="text-italic text-red"><small>*If this is not your active mobile number, please contact IT to update your number.*</small></p>
        </div>
        <div class="hris-modal-footer">
          <q-btn unelevated label="Please Send" class="hris-q-primary" @click="sendPayslipPassword"></q-btn>
        </div>
      </div>
    </q-dialog>
    <q-dialog v-model="spinner" persistent>
      <div class="hris-loading">
        <q-spinner color="green" size="3em"></q-spinner>
      </div>
    </q-dialog>
  </div>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';
export default {
  data () {
    return {
      alert:false,
      mobile:'',
      spinner:false,
    }
  },

  mounted(){
    this.eventHub.$on('forgotPassword', this.confirmPassword);
  },


  methods:{
   sendPayslipPassword: function(){
      this.spinner = true
     axios.create({
         baseURL: this.apiUrl,
         headers: {
           'Authorization': `Bearer ${this.token}`
         }
      }).get(`/payslip/password/${this.userData.employee_id}/${this.mobile}`)
      .then((res) => {
         if(res.data.status){
            this.alert = false
            this.spinner = false
            this.$q.notify({
              color: 'green-6',
              textColor: 'white',
              icon: 'fa fa-check-circle',
              message: res.data.data
            });
         }
      })
   },

   confirmPassword(payload) {
      this.alert = payload.stat
      this.mobile = payload.mobile
   },


   }
}
</script>
